import i18n from "config/i18next";

i18n.addResources("es", "restorePassword", {
  newPassword: "Nueva contraseña",
  confirmNewPassword: "Repetir nueva contraseña",
  passwordMustHave: "La contraseña debe contar con",
  passwordMinLength: "8 o más caracteres",
  upperCaseandLowerCase: "Mayúsculas y minúsculas",
  numbersAndLeters: "Números y letras",
  save: "Guardar",
  passwordNotMatch: "Las contraseñas no coinciden",
  expiredCodeTitle: "Código de verificación vencido",
  expiredCodeMessage:
    "Se venció el plazo de recuperación de tu contraseña. Solicitala nuevamente",
  successfulRestoreTitle: "Restauraste tu contraseña exitosamente",
  successfulRestoreMessage: "Ya podés ingresar con tu nueva contraseña.",
});
